<template>
    <!-- <div :id="'contPanel' +  this.contBoxId"  v-observe-visibility="this.visibilityChanged()"> -->
    <div :id="'contPanel' +  this.contBoxId" >
      <div class="GlobalTableCheck">
        <form class="Form">
          <div class="FormRow">
            <div class="FormBoxWide">
              <div class="BoxWide">
                <div class="Bookmark Linked">
                  <span></span>
                  <div class="Button ExtraSmall">
                    <input type="button" id="" name="" value="Segna tutti con esito Positivo" @click="this.eseguiTutte()" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="Counter">
        <div class="BoxTabellaDettaglio" v-for="(attivita,index) in this.listaAttivita" :key="index">      
            <PannDettInterventiInCorsoRiga 
            :attivita="attivita"
            :chiaveIntervento="this.chiaveIntervento"
            :index="index"
            >
            </PannDettInterventiInCorsoRiga>
        </div>
      </div>
    </div>
</template>
<script>
import PannDettInterventiInCorsoRiga from "@/components/PannDettInterventiInCorsoRiga.vue";
import AttivitaIntervento from "@/models/attivitaIntervento.model.js";
import {apiMixin} from "/mixin.js";

export default {
    name: "PannDettInterventiInCorso",
    data(){
      return {
        listaAttivita: null,
        contBoxId:  this.codiceIntervento.replace(" ", "").replace("/", ""),
      }
    },
    mixins:[apiMixin],
    props:{       
        chiaveIntervento: String,
        codiceIntervento: String     
    },
    watch:{
      codiceIntervento: function(newValue){        
        this.contBoxId = newValue.replace(" ", "").replace("/", ""); 
      },     
    },    
    components: {
      PannDettInterventiInCorsoRiga
    },  
    methods: {
      eseguiTutte(){
          let postBody = {
            CodiceIntervento: this.codiceIntervento
          };
          
          this.doApiCall("post", "interventi/SetAttivitaEseguiteWeb", this.$store.getters.getUtente.Token, null, postBody).then(
                (data) => {  
                    if(data && data.StatusCode === 200){                    
                        this.$toast.success("Attività aggiornata con successo!", {position:"top-right"});                       
                        this.listaAttivita = data.Data;
                    }
                    else{
                        this.$toast.error("Attenzione! Si sono verificati errori durante l'aggiornamento delle attività!", {position:"top-right"});
                    }
                }
            );
      }
    },
    created(){
        let params = {
            CodiceIntervento: this.codiceIntervento
        };
        this.doApiCall("get", "interventi/GetAttivita", this.$store.getters.getUtente.Token, params).then(
            (data) => {                
                if(data){                                          
                    this.listaAttivita = data.map(o => {
                        return Object.assign(new AttivitaIntervento(), o)
                    });                                  
                }                    
                
            }
        )
    }
}
</script>

<style>
.Bookmark{
  margin-bottom: 0px;
  border-left: 0px;
}
</style>